import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {GenericActionComponent, GenericActionComponentsMethods} from "../generic-action.component";
import {CarePlanServiceGroupType} from "../../models/care-plan-service-group-type.model";
import {Client} from "../../models/client.model";
import {Subscription} from "rxjs";
import {CommonUtils} from "../../utils/common";
import {FormBuilder, Validators} from "@angular/forms";
import {AppStateService} from "../../providers/app-state.service";
import {ModalController, ToastController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {Router} from "@angular/router";
import {ClientsService} from "../../providers/clients.service";
import {ItemFinderComponent} from "../item-finder/item-finder.component";
import {CarePlanServiceGroupTypeService} from "../../providers/care-plan-service-group-type.service";

@Component({
  selector: 'app-edit-care-plan-service-group-type',
  templateUrl: './edit-care-plan-service-group-type.component.html',
  styleUrls: ['./edit-care-plan-service-group-type.component.scss'],
})
export class EditCarePlanServiceGroupTypeComponent extends GenericActionComponent implements OnInit, OnDestroy, GenericActionComponentsMethods {

  @Input() carePlanServiceGroupType: CarePlanServiceGroupType;
  @Input() csrfToken: string;

  @Output() objectEditedEmitter = new EventEmitter<CarePlanServiceGroupType>();
  @Output() objectAddedEmitter = new EventEmitter<CarePlanServiceGroupType>();
  @Output() hasUnsavedChangesEmitter = new EventEmitter<boolean>();

  hasUnsavedChanges: boolean = false;
  isAdmin: boolean;
  isGeneralAdmin: boolean;

  isBusy: boolean;
  private isClientAdmin: boolean;
  private isGeneralWellnessPlanAdmin: boolean;
  clientSelected: Client;
  private subscriptions: Subscription = new Subscription();


  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private appStateService: AppStateService,
    private toastController: ToastController,
    private modalController: ModalController,
    private translateService: TranslateService,
    private vetClinicService: VetClinicService,
    private router: Router,
    private carePlanServiceGroupTypeService: CarePlanServiceGroupTypeService,
    private clientsService: ClientsService
  ) {
    super(commonUtils, appStateService, modalController, translateService);
  }

  ngOnInit() {
    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });


    this.isAdmin = this.user.roles.split(';').filter(e => e === 'admin').length === 1;
    this.isGeneralWellnessPlanAdmin = this.user.vClientId === null && this.user.vetcodeId === null && this.user.roles.split(';').filter(e => e === 'wellness-plan').length === 1;
    this.isGeneralAdmin = this.isAdmin && this.user.vClientId === null && this.user.vetcodeId === null;
    this.isClientAdmin = this.isAdmin && this.user.vClientId !== null && this.user.vetcodeId === null;


    if (this.action === 'ADD') {
      this.componentTitle = 'Dodaj nową grupę usług';
      this.actionBtnLabel = 'Dodaj nową grupę usług';
      this.actionQuestion = 'Na pewno chcesz dodać nową grupę usług?';
      this.actionSuccess = 'Nowa grupa usług została dodana';
      this.actionError = 'Wystąpił błąd podczas dodawania nowej grupy usług'
      this.formGroup = this.formBuilder.group({
        name: ['', [Validators.required]],
        description: ['', [Validators.required]]
      });

      if (this.user.vClientUUID) {
        this.appStateService.updateIsBusySubject(true);
        this.registerSubscription(this.clientsService.getClientByUUID(this.user.vClientUUID).subscribe(client => {
          if (client) {
            this.clientSelected = client;
          }
          this.appStateService.updateIsBusySubject(false);
        }, error => {
          this.appStateService.updateIsBusySubject(false);
        }));
      }

    } else {
      if (this.carePlanServiceGroupType.vClientId) {
        this.appStateService.updateIsBusySubject(true);
        this.registerSubscription(this.clientsService.getClientById('' + this.carePlanServiceGroupType.vClientId).subscribe(client => {
          if (client) {
            this.clientSelected = client;
          }
          this.appStateService.updateIsBusySubject(false);
        }, error => {
          this.appStateService.updateIsBusySubject(false);
        }));

      }

      this.componentTitle = 'Zmień grupę usług';
      this.actionBtnLabel = 'Zmień grupę usług';
      this.actionQuestion = 'Na pewno chcesz zmienić grupę usług?';
      this.actionSuccess = 'Grupoa usług została zmieniona';
      this.actionError = 'Wystąpił błąd podczas zmiany grupy usług';
      this.formGroup = this.formBuilder.group({
        name: [this.carePlanServiceGroupType.name, [Validators.required]],
        description: [this.carePlanServiceGroupType.description, [Validators.required]]
      });

    }

    super.ngOnInit();
  }


  onCancelEdit() {
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany, czy na pewno chcesz zrezygnować?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.hasUnsavedChanges = false;
        this.actionCanceledEmitter.emit(true);
      }, () => {
      });
    } else {
      this.commonUtils.presentYesNoActionSheet('Czy na pewno chcesz zrezygnować?', 'Tak', 'Nie', 'checkmark-outline', 'close', () => {
        this.actionCanceledEmitter.emit(true);
        this.hasUnsavedChanges = false;
      }, () => {
      });
    }
  }

  goTo(page: string) {
    this.router.navigateByUrl(page);
  }


  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChangesEmitter.emit(true);
    }
    super.markUnsavedChanges();
  }

  onAction() {
    if (this.formGroup.valid) {
      this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        let cps: CarePlanServiceGroupType = this.commonUtils.formGroupValuesToObject<CarePlanServiceGroupType>(new CarePlanServiceGroupType(), this.formGroup);

        let serviceMethod;

        this.carePlanServiceGroupType.name = cps.name;
        this.carePlanServiceGroupType.description = cps.description;
        if (this.clientSelected) {
          console.log(this.clientSelected)
          this.carePlanServiceGroupType.vClientId = this.clientSelected.id;
        } else {
          this.carePlanServiceGroupType.vClientId = Number.parseInt(this.user.vClientId);
        }

        if (this.action === 'EDIT') {
          serviceMethod = this.carePlanServiceGroupTypeService.update(this.carePlanServiceGroupType);
        } else {
          serviceMethod = this.carePlanServiceGroupTypeService.add(this.carePlanServiceGroupType);
        }

        this.handleActionMethod(serviceMethod, this.objectAddedEmitter, this.objectEditedEmitter);

      }, () => {
      });
    } else {
      this.commonUtils.presentAlertToast('Popraw błędy w formularzu');
    }
  }


  async onSearchClients() {
    const modal = await this.modalController.create({
      component: ItemFinderComponent,
      componentProps: {
        title: 'Wyszukaj klienta',
        itemType: 'clients',
        nameToFind: this.clientSelected ? this.clientSelected.name : ''
      }
    });

    modal.onWillDismiss().then(data => {
      if (data && data.data) {
        this.clientSelected = data.data;
      }
    });

    return await modal.present();
  }


  registerSubscription(sub: Subscription) {
    if (sub) {
      this.subscriptions.add(sub);
    }
  }

}
